import type { PurposeOption } from "@/components/form/purpose-select";
import PurposesSelect from "@/components/form/purposes-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a list of whole purpose objects**, not ids. */
export type OrderPurposesFieldProps = PickerFieldProps<PurposeOption[]>;

export const OrderPurposesField = makePickerField<PurposeOption[]>({
  name: "OrderPurposesField",
  control: PurposesSelect,
  popout: true,
});
